jQuery(function($) {

  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);
  

  function init() {
  	replaceAddToCartButton();
  }
 
    
function replaceAddToCartButton() { 
	$('.cpb-add-to-cart-button').find('span').html('Finalize Design');
  

   document.querySelector('.cpb-add-to-cart-button').addEventListener('click',additionalevents);                                                                                                                                 
  }
 
                                                                      function additionalevents (){
    	
     const open = window.XMLHttpRequest.prototype.open;
	 $('.loader-inactive').removeClass();  
	 function openReplacement() {
 	 this.addEventListener("load", function () {
   	 if (
     	["/cart/add.js",
      	].includes(this._url)
  		) {
      	calculateShipping(this.response);
    	}
 		 });
 	 return open.apply(this, arguments);
		}      
   		window.XMLHttpRequest.prototype.open = openReplacement;  
      }
  

		function calculateShipping(cartJson) {

      
		$.getJSON('/cart.js', function(cart){ 
			var result = cart.items[0].url;
            var pID = cart.items[0].id;
			console.log(result);
          	console.log(pID);
          
        $.ajax({
     	   type: 'POST',
     	   url: '/cart/change.js',
    	    dataType: 'json',
    	    data: {
            quantity: 0,
            id: pID
        		  },
        success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
					console.log("remove from cart sucessful");
          	    window.setTimeout(function(){
   		window.location.href = "https://third-degree-sports.myshopify.com" + result;
		 }, 3000); 
                }
               });
       		}
   			 });  
            });
  		}


});